import React, { MouseEventHandler, useCallback } from 'react';

import { MessageType, Reaction } from '@/graphql';

import { MessageContent } from './components/MessageContent';
import { MessageSetlist } from './components/MessageSetlist';
import { MessageSonglist } from './components/MessageSonglist';

export interface RenderMessageProps {
	id: string;
	chatId: string;
	type: MessageType;
	content: string;
	metadata?: string | null;
	isAuthor: boolean;
	isBot: boolean;
	/* Whether the content is replied message, so it should increase bottom padding */
	isReplied?: boolean;
	isReply?: boolean;
	isSending?: boolean;
	isFocused: boolean;
	deleted?: boolean;
	onClick?: (messageId: string) => void;
	setFocusedMessageId: React.Dispatch<
		React.SetStateAction<string | undefined>
	>;
	reactions?: Reaction[];
	position?: 'first' | 'middle' | 'last';
	className?: string;
	isUserStatsOpen?: boolean;
}

export type MessageCommonProps = Pick<
	RenderMessageProps,
	| 'content'
	| 'metadata'
	| 'isSending'
	| 'isAuthor'
	| 'isBot'
	| 'isFocused'
	| 'setFocusedMessageId'
	| 'id'
	| 'reactions'
	| 'chatId'
	| 'position'
	| 'onClick'
	| 'className'
	| 'isUserStatsOpen'
>;

export const RenderMessage = ({
	id,
	chatId,
	type,
	content,
	metadata,
	isAuthor,
	isBot,
	onClick,
	isReplied = false,
	isReply = false,
	isSending = false,
	deleted = false,
	setFocusedMessageId,
	isFocused,
	reactions,
	position,
	className,
	isUserStatsOpen,
}: RenderMessageProps) => {
	const commonProps = {
		id,
		chatId,
		content,
		metadata,
		isSending,
		isAuthor,
		isBot,
		isFocused,
		setFocusedMessageId,
		reactions,
		position,
		onClick,
		className,
		isUserStatsOpen,
	};
	switch (type) {
		case MessageType.Text:
			return <MessageContent {...commonProps} />;
		case MessageType.Status:
			return <MessageContent status {...commonProps} />;
		case MessageType.Songlist:
			return <MessageSonglist {...commonProps} />;
		case MessageType.Setlist:
			return <MessageSetlist {...commonProps} />;
		default:
			return <MessageContent {...commonProps} />;
	}
};
